import React from "react";
import { Input } from "./ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "./ui/button";

export const SearchView = ({
  searchParams,
  handleSearch,
  statusOptions = [],
  countryOptions = [],
  yearOptions = [],
  typeOptions = [],
  relatedUserOptions = [],
  companyTypeOptions = [],
  relatedUserLoading = false,
  resetDefault,
}) => {
  return (
    <div>
      <div className="flex flex-row gap-2 mb-4">
        {Object.entries(searchParams).map(([key, value]) =>
          key === "status" && statusOptions.length > 0 ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder={`Filter by ${key}`} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : key === "country" ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder={`Filter by ${key}`} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {countryOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : key === "year" ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder={`Filter by ${key}`} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {yearOptions.map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : key === "type" && typeOptions.length > 0 ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder={`Filter by type`} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {typeOptions.map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : key === "companyType" && companyTypeOptions.length > 0 ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder="Filter by Şirket Türü" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {companyTypeOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : key === "relatedUser" ? (
            <Select
              key={key}
              value={value || undefined}
              onValueChange={(newValue) =>
                handleSearch({ key, value: newValue === "all" ? "" : newValue })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder={relatedUserLoading ? "Loading..." : "Filter by Related User"} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {relatedUserOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <Input
              key={key}
              value={value}
              placeholder={key}
              onChange={(e) => handleSearch({ key, value: e.target.value })}
            />
          )
        )}
        {resetDefault && (
          <Button onClick={resetDefault}>Tüm Filtreleri Sıfırla</Button>
        )}
      </div>
    </div>
  );
};
